import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { MaphelperService } from "src/app/app-analysis-module/maphelper.service";
import { CommonServiceService } from "src/app/common-module/common-service.service";
import { IsochroneService } from "src/app/isochrone-module/isochrone.service";
import { AssignUserPopupComponent } from "../assign-user-popup/assign-user-popup.component";
import { AssignUserService } from "../assign-user.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'app-assign-user-tool',
  templateUrl: './assign-user-tool.component.html',
  styleUrls: ['./assign-user-tool.component.css']
})
export class AssignUserToolComponent implements OnInit, OnDestroy {

  geometry = [];
  loader: boolean = false;
  layerId;
  @Input() mapid;

  @Input() draw:any;
  @Input() mapLayers: any;
  @Input() multiplePolygon
  @Input() cordinates :any;
  @Output() showInfo = new EventEmitter<any>();
  @Output() addLayerOnMapLayer = new EventEmitter<any>()
  @Output() setStyleDetailsInMap = new EventEmitter<any>()
  @Output() TurnOffAndOnLayer = new EventEmitter<any>()
  @Output() SetTerritoryLayersType = new EventEmitter<any>()

  @Output() EmitSelectedLayer = new EventEmitter<any>()
  @Input() mapCarto: any;
  @Input() ModuleName:any
  @Input() drawData






  constructor(

    private matDialog: MatDialog,
    private _isochroneService: IsochroneService,
    private router: Router,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private commonService: CommonServiceService,
    private mapHelperService: MaphelperService,
    private AssignUserService: AssignUserService
  ) {
    this.mapid = this.route.snapshot.paramMap.get("share_map_id");
    this.layerId = this.route.snapshot.paramMap.get("done");
    this.commonService.EnableDrawGLStyle.next(false);
  }




  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges){
    try{
      if(changes.drawData.currentValue){
        this.FeatureHighlightedByLasso(changes.drawData.currentValue)
        }
    }catch{
      
    }

  }



  //New code For assign user

  SelectedModel = "lasso"
  @Output() SelectedModelEmit = new EventEmitter<any>()
  firstLayerSelected: any;
  getAddDataType(moduleName) {
    this.SelectedModel = moduleName
    this.SelectedModelEmit.emit(moduleName)
    this.RemoveSelectedToolData(moduleName)
    this._isochroneService.removeCursorPopUpFromMap(this.mapCarto);
    this.multiPolygon = true;
    // this.stepper.reset();
  }

  RemoveSelectedToolData(moduleName) {
    if (moduleName == "lasso") {
      this.RemoveMultiHighlightGid()
      this.DeleteLassoToolData()
    }
    else if (moduleName == "select_polygon") {
      this.RemoveMultiHighlightGid()
      this.DeleteLassoToolData()
    }
    else if (moduleName == 'create_polygon') {
      this.RemoveMultiHighlightGid()
      this.DeleteLassoToolData();
      this.multiplePolygon = false;
    }
    this.geometry = []
    this.cordinates = false
  }


  layerIdChange(data){
   if(data.layer_type == "POLYLINE" || data.layer_type == "POINT" ){
    this._isochroneService.openSnackBar("Please Select Polygon file", "snackbar-error", "fail");
    this.firstLayerSelected = false
    }else{
      this.EmitSelectedLayer.emit(this.firstLayerSelected)
    } 
  }


  RemoveMultiHighlightGid() {
    if (this.firstLayerSelected) {
      this.mapHelperService.reomveHighlightGid(this.mapCarto, this.firstLayerSelected.identity,true)
      this.draw.deleteAll()
    }
  }

  multiPolygon = true
  //MultiSelect Polygon Methods
  OnSelectMultipolygon() {
    this.multiPolygon = false
    this.RemoveMultiHighlightGid()
    this.showInfo.emit(true)
    // this.mapComponent.showInfo.close()

    this.mapHelperService.ListenMapPopup.next(false)
    this.mapHelperService.VectorFeatureModal.next(false)
    this.mapHelperService.MultiSelectFeature = true
    this._isochroneService.showCursorPopUpOnMap(this.mapCarto, 'Click on the feature to select');
  }



  DeleteSelectPoly() {
    this.multiPolygon = true

    this.RemoveMultiHighlightGid()
    this.mapHelperService.MultiSelectFeature = false
    this.mapHelperService.GidCollection = []

    this._isochroneService.removeCursorPopUpFromMap(this.mapCarto);
    // this.mapHelperService.ListenMapPopup.next(true)
    // this.mapHelperService.VectorFeatureModal.next(true)

  }



  //Lasso Tool Methods
  DeleteLassoToolData() {
    this.draw.deleteAll()
    if (this.tempLayer) {
      this.mapHelperService.removeLayerFromMap(this.mapCarto, this.tempLayer, this.tempLayerMultiple);
      this.tempLayer = false;
    }

    this.mapHelperService.MultiSelectFeature = false
    this.mapHelperService.GidCollection = []
    this.mapHelperService.ListenMapPopup.next(true)
  }

  LassoReset(event) {
    if (event) {
      this.DeleteLassoToolData()
    }
  }

  tempLayer: any;
  tempLayerMultiple
  IsLoader = false;
  tempLayerView
  FeatureHighlightedByLasso(cordinates) {
    this.cordinates = cordinates

    if(this.tempLayer) {
      this.mapHelperService.removeLayerFromMap(this.mapCarto, this.tempLayer, this.tempLayerMultiple);
      this.tempLayer = false
    }

    let finalcordinates = JSON.stringify({
      "type": "Polygon",
      "coordinates": cordinates.features[0].geometry.coordinates
    })

    this.IsLoader = true
    this.AssignUserService.getLassoTool(this.firstLayerSelected.layerid, finalcordinates, "intersects", "")
      .subscribe(val => {

        if (val.data.feature_count > 0) {

          let finalResult = val.data;

          this.mapHelperService.getLayerJsonData(finalResult.dbzxvuwyacs, finalResult.view).subscribe(data => {
            let tileurl = data["tileurl"] + "?update=" + Math.random();
            console.log(tileurl)
            let layerMapDetails = this.mapHelperService.addLayers(data.id, data["geometrytype"], tileurl, this.mapCarto, 0, "#484896");
            this.tempLayer = layerMapDetails.source;
            this.tempLayerView = finalResult.view
            this.tempLayerMultiple = layerMapDetails.multiple
            this.mapCarto.fitBounds(data['bounds']);
            this.mapCarto = layerMapDetails.map;
            finalResult.proximityLayer = layerMapDetails.source;
            finalResult.isMultiple = layerMapDetails.multiple;;
            this._isochroneService.openSnackBar("Your draw result generated successfully", "snackbar-success", "success");

            this.IsLoader = false

          });

        }
        else {
          this._isochroneService.openSnackBar("No Feature Selected", "snackbar-error", "fail");
          this.IsLoader = false
        }

      })

  }


  AssignUserLoader = false
  AssignUser(SelectedModel) {


    console.log(this.cordinates);
    if (SelectedModel == 'lasso') {
      if (!this.tempLayer) {
        this._isochroneService.openSnackBar("Please Draw a Polygon Before Assign to User", "snackbar-error", "fail");
        return
      }
    } else if (SelectedModel == 'select_polygon') {

      let gidData: any = this.mapHelperService.GidCollection
      if (gidData.length == 0) {
        this._isochroneService.openSnackBar("Please Select Polygon Before Assign to User", "snackbar-error", "fail");
        return
      }
    }
    else if (SelectedModel == 'create_polygon') {
      if (!this.cordinates) {
        this._isochroneService.openSnackBar("Please Draw a Polygon Before Assign to User", "snackbar-error", "fail");
        return
      }

    }


    let index = this.mapLayers.findIndex((a) => a.subuser_layer == "1")
    let SubUserLayer = this.mapLayers[index] 

    const assignUserPopup = this.matDialog.open(AssignUserPopupComponent, {
      width: "70%",
      data: { "SelectedModel": SelectedModel, "mapid": this.mapid, "SubUserLayer":SubUserLayer, "Module":'ShareAssign'}
    })

    let dialogBoxData
    assignUserPopup.afterClosed().subscribe(data => {
        console.log(data)
        dialogBoxData = data
        this.AddUserLayeronMap(dialogBoxData,SelectedModel)
      })
  }


  AddUserLayeronMap(dialogBoxData,SelectedModel){

    if (dialogBoxData) {
      let data = dialogBoxData
      this.AssignUserLoader = true
      let params
      let finalSubuserStyle
      let layer
    //   this.AssignUserService.getAllLayersOfTerritory(this.mapid)
    //   .subscribe(
    //     data2 => {
    //       console.log("layer Load", data2);
    //       layer = data2.data.data
    //       // let index1 = this.mapLayers.findIndex((a) => a.subuser_layer == "1")
    //       // if(index1==-1){
    //       //     this.addLayerOnMapLayer.emit(layer)
    //       // }
    //     // })
    //     let index
    //     if(layer){
    //     index = layer.findIndex((a) => a.layerid == this.firstLayerSelected.layerid)
        

    //   if (layer[index].subuser_layers_data.length > 0) {
    //     finalSubuserStyle = layer[index].style_details
    //   }
    //  } else {
    //     finalSubuserStyle = null
    //   }
    //   // let finalSubuserStyle = data.SubUserLayer == undefined ?  null : data.SubUserLayer.style_details

    //   if (SelectedModel == "lasso") {

    //     params = {
    //       "territory_name": data.territory_name,
    //       "mapid": this.mapid,
    //       "userid_forAssign": data.userid_forAssign,
    //       "style_details": finalSubuserStyle,
    //       // "bounding_coordinates":this.cordinates,
    //       "layerid":this.firstLayerSelected.layerid,
    //       "view_table": this.tempLayerView,
    //     }
    //   }

    //   else if (SelectedModel == "select_polygon") {

    //     let gid;
    //     if (this.firstLayerSelected.raster_on == 0) {
    //       gid = this.mapHelperService.GidCollection;
    //     }
    //     else {
    //       let gid2 = [];
    //       this.mapHelperService.GidCollection.forEach((element, index) => {
    //         let data = this.mapHelperService.GidCollection[index].properties.gid;
    //         gid2.push(data);
    //         gid = gid2;
    //       });
    //     }

    //       params = {
    //         "territory_name": data.territory_name,
    //         // "color": "#484896",
    //         "gid": gid,
    //         "layerid": this.firstLayerSelected.layerid,
    //         "mapid": this.mapid,
    //         "userid_forAssign": data.userid_forAssign,
    //         "style_details": finalSubuserStyle
    //       }
    //     }

    //   else if (SelectedModel == "create_polygon") {
    //       params = {
    //         "territory_name": data.territory_name,
    //         "mapid": this.mapid,
    //         "userid_forAssign": data.userid_forAssign,
    //         "bounding_coordinates": this.cordinates,
    //         "style_details": finalSubuserStyle
    //       }
    //     }

    //     this.AssignUserService.SetUserOnMapSchemaForAssignUser(params).subscribe(result => {
    //       this.AssignUserLoader = false
    //       if (result.http_code == 200 && data) {
    //         if (!finalSubuserStyle) {
    //           let layer =  [result.data]
    //           this.addLayerOnMapLayer.emit(layer)
    //         }
    //         // else {
    //           // let index = this.mapComponent.mapLayers.findIndex((a) => a.layerid == result.data.layerid)
    //           // this.mapComponent.mapLayers[index].style_details = finalSubuserStyle
    //           // this.mapComponent.onChangesLayerMeStyle(index,finalSubuserStyle)

    //           setTimeout(() => {
    //             let sendData = {layerid: result.data.layerid, finalSubuserStyle:result.data.style_details }
    //           this.setStyleDetailsInMap.emit(sendData)
    //           this.SetTerritoryLayersType.emit([result.data])
    //           this.TurnOffAndOnLayer.emit(result.data.layerid)
    //           }, 500);

              
    //           // this.mapComponent.TurnOffAndOnLayer(result.data.layerid)
    //         // }

    //         this._isochroneService.openSnackBar(result.message, "snackbar-success", "success")
    //         this._isochroneService.removeCursorPopUpFromMap(this.mapCarto);

    //         this.RemoveSelectedToolData(this.SelectedModel)

    //       } else {
    //         this._isochroneService.openSnackBar(result.message, "snackbar-error", "fail")
    //       }

    //     }, (err => {
    //       this._isochroneService.openSnackBar("Error in Data", "snackbar-error", "fail")
    //       this.AssignUserLoader = false
    //     }))
    //   })


      }
  }




 
  ngOnDestroy(){

    // this.commonService.EnableDrawGLStyle.next(false);
    // this.mapHelperService.MultiSelectFeature = false
    // this.mapHelperService.ListenMapPopup.next(true)
  // this.mapHelperService.VectorFeatureModal.next(true)
    this.mapHelperService.GidCollection = []
    this._isochroneService.removeCursorPopUpFromMap(this.mapCarto);

  }


}
